import { render, staticRenderFns } from "./ExpandableListBlock.vue?vue&type=template&id=0254286c"
import script from "./ExpandableListBlock.vue?vue&type=script&lang=js"
export * from "./ExpandableListBlock.vue?vue&type=script&lang=js"
import style0 from "./ExpandableListBlock.vue?vue&type=style&index=0&id=0254286c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports